import { useClient } from 'ui-hooks/useClient';
import { useRouter } from 'next/navigation';
import { useCallback } from 'react';

export const useRequestMarketingAgreement = () => {
  const router = useRouter();
  const { isApp } = useClient();

  return useCallback(() => {
    if (isApp) {
      router.push('diritto://accounts/diritto-account');
    } else {
      router.push('/accounts/diritto-account');
    }
  }, [isApp, router]);
};
